import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { Trilha } from '../../components/Trilha';

/* Medidas e cores do protótipo de notícias (copasul-noticias.html), valendo só
   dentro destas páginas. Os nomes das cores são os da galeria. */
const serifa = "Georgia, 'Times New Roman', serif";

export const Pagina = styled.div`
  --verde: #008d3c;
  --verde-escuro: #0b4e30;
  --tinta: #143e2d;
  --apagado: #6b7b72;
  --linha: #dce5dd;
  --papel: #fff;
  --amarelo: #ffb71b;
  --foco: #103f2d;
  --gutter: clamp(1.375rem, 4vw, 2.5rem);

  background: var(--papel);
  color: var(--tinta);
  font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif;
  text-align: left;

  a {
    color: inherit;
    text-decoration: none;
  }

  button,
  input,
  select {
    font: inherit;
    color: inherit;
  }

  button {
    cursor: pointer;
    background: transparent;
  }

  a:focus-visible,
  button:focus-visible {
    outline: 3px solid var(--amarelo);
    outline-offset: 4px;
  }

  input:focus,
  select:focus {
    outline: none;
  }

  img {
    display: block;
  }

  @media (prefers-reduced-motion: reduce) {
    *,
    *::before,
    *::after {
      transition: none !important;
      animation: none !important;
    }
  }
`;

export const Container = styled.div`
  width: 100%;
  max-width: 1360px;
  margin-inline: auto;
  padding-inline: var(--gutter);
  box-sizing: border-box;
`;

export const TrilhaDaPagina = styled(Trilha)`
  padding-top: clamp(1.5rem, 3vw, 2.2rem);
`;

const Chapeu = css`
  font-size: 0.625rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--verde);
`;

/* ------------------------------------------------------------- abertura */

export const Abertura = styled.section`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 2.2rem;
  margin: 2.4rem 0 2.6rem;

  h1 {
    margin: 0;
    font-size: clamp(2.6rem, 4.6vw, 4.05rem);
    font-weight: 500;
    line-height: 1.08;
    letter-spacing: -0.03em;
    text-wrap: balance;
  }

  h1 em {
    font-style: normal;
    color: var(--verde);
  }

  @media (max-width: 720px) {
    display: block;
    margin: 2rem 0 1.75rem;

    h1 {
      font-size: 2.75rem;
      letter-spacing: -0.035em;
    }
  }
`;

export const Nota = styled.div`
  flex-shrink: 0;
  max-width: 22rem;
  padding-left: 1.55rem;
  border-left: 1px solid var(--linha);

  strong {
    display: block;
    font-size: 1.25rem;
    font-weight: 400;
    line-height: 1.4;
  }

  p {
    margin: 0.75rem 0 0;
    font-size: 0.8125rem;
    line-height: 1.8;
    color: var(--apagado);
  }

  @media (max-width: 720px) {
    margin-top: 1.25rem;
    padding-left: 0;
    border-left: 0;

    strong {
      font-size: 1rem;
    }

    p {
      display: none;
    }
  }
`;

/* --------------------------------------------------------------- em foco */

export const EmFoco = styled.section`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  min-height: 28rem;
  background: var(--foco);
  color: #fff;

  @media (max-width: 720px) {
    display: flex;
    flex-direction: column-reverse;
  }
`;

export const FocoTexto = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  padding: 2.25rem 2.4rem 2.5rem;

  time {
    font-size: 0.75rem;
    color: #b5d1c0;
  }

  h2 {
    margin: 1rem 0 1.4rem;
    font-family: ${serifa};
    font-size: clamp(1.8rem, 2.9vw, 2.7rem);
    font-weight: 400;
    line-height: 1.13;
    letter-spacing: -0.02em;
  }

  p {
    max-width: 26rem;
    margin: 0 0 1.75rem;
    font-size: 0.9375rem;
    line-height: 1.8;
    color: #d1ded3;
  }

  @media (max-width: 1050px) {
    padding: 1.75rem;

    h2 {
      font-size: 2.125rem;
    }
  }

  @media (max-width: 720px) {
    padding: 1.6rem 1.5rem 1.75rem;
  }
`;

export const Kicker = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1.75rem;
  font-size: 0.6875rem;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: #c9dec8;

  &::before {
    content: '';
    width: 0.45rem;
    height: 0.45rem;
    border-radius: 50%;
    background: var(--amarelo);
  }

  &::after {
    content: '';
    flex: 1;
    height: 1px;
    background: rgba(255, 255, 255, 0.21);
  }

  @media (max-width: 720px) {
    margin-bottom: 1.25rem;
  }
`;

export const FocoAcao = styled.div`
  margin-top: auto;
  padding-top: 1.25rem;
  border-top: 1px solid rgba(255, 255, 255, 0.19);

  a {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1.25rem;
    font-size: 1rem;
  }

  a > span:first-child {
    transition: color 0.2s;
  }

  a > span:last-child {
    display: grid;
    place-items: center;
    flex: 0 0 2.25rem;
    width: 2.25rem;
    height: 2.25rem;
    border-radius: 50%;
    background: var(--amarelo);
    color: #153a2a;
    transition: transform 0.25s ease;
  }

  /* Só o texto acende: o link ocupa a largura toda, mas o hover vale no texto. */
  a > span:first-child:hover,
  a:focus-visible > span:first-child {
    color: var(--amarelo);
  }

  a > span:first-child:hover + span,
  a:focus-visible > span:last-child {
    transform: rotate(45deg);
  }
`;

export const FocoFoto = styled(Link)`
  position: relative;
  display: block;
  min-height: 28rem;
  overflow: hidden;
  background: #0b3324;

  img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 450ms ease;
  }

  &:hover img {
    transform: scale(1.025);
  }

  /* Legenda como nas fotos da Sustentabilidade: aparece com o mouse em cima,
     numa faixa que escurece só a base da foto. */
  span {
    position: absolute;
    inset: auto 0 0 0;
    padding: 1.5rem;
    font-size: 0.75rem;
    line-height: 1.45;
    color: #fff;
    background: linear-gradient(0deg, rgba(27, 36, 32, 0.78), rgba(27, 36, 32, 0));
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &:hover span {
    opacity: 1;
  }

  /* Sem hover no toque: a legenda fica sempre à vista. */
  @media (hover: none) {
    span {
      opacity: 1;
    }
  }

  @media (max-width: 720px) {
    min-height: 15rem;
  }
`;

/* -------------------------------------------------------------- arquivo */

export const Arquivo = styled.section`
  display: grid;
  grid-template-columns: 16.25rem minmax(0, 1fr);
  gap: 3.4rem;
  align-items: start;
  margin: 3.4rem 0 3.1rem;

  @media (max-width: 1150px) {
    grid-template-columns: 13.75rem minmax(0, 1fr);
    gap: 1.75rem;
  }

  @media (max-width: 950px) {
    grid-template-columns: 11.875rem minmax(0, 1fr);
  }

  @media (max-width: 720px) {
    display: block;
    margin-top: 2.2rem;
  }
`;

export const Filtros = styled.aside`
  /* Só começa a acompanhar a rolagem quando "Publicações" chega ao topo. */
  position: sticky;
  top: 2rem;
  padding-right: 1.75rem;
  border-right: 1px solid var(--linha);

  > p {
    ${Chapeu}
    margin: 0 0 1rem;
  }

  h2 {
    margin: 0 0 1.9rem;
    font-size: 1.5625rem;
    font-weight: 500;
    line-height: 1.2;
    letter-spacing: -0.02em;
  }

  label,
  legend {
    display: block;
    margin-bottom: 0.8rem;
    padding: 0;
    font-size: 0.8125rem;
    font-weight: 600;
  }

  fieldset {
    margin: 1.75rem 0 0;
    padding: 0;
    border: 0;
  }

  @media (max-width: 1150px) {
    padding-right: 1.25rem;
  }

  @media (max-width: 720px) {
    position: static;
    margin-bottom: 1.9rem;
    padding: 0 0 1.5rem;
    border-right: 0;
    border-bottom: 1px solid var(--linha);

    h2 {
      margin-bottom: 1.25rem;
      font-size: 1.5rem;
    }

    fieldset {
      margin-top: 1.25rem;
    }
  }
`;

export const CampoBusca = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding-bottom: 0.6rem;
  border-bottom: 1px solid #a9bfb0;

  svg {
    flex-shrink: 0;
    color: var(--apagado);
  }

  input {
    width: 100%;
    min-width: 0;
    padding: 0.4rem 0;
    border: 0;
    background: transparent;
    font-size: 0.875rem;
  }

  input::-webkit-search-cancel-button {
    display: none;
  }

  /* Celular: 16px evita o zoom automático do iPhone ao tocar no campo; e
     mais altura para o dedo. */
  @media (max-width: 720px) {
    input {
      padding: 0.6rem 0;
      font-size: 1rem;
    }
  }

  button {
    display: grid;
    place-items: center;
    padding: 0.2rem;
    border: 0;
    color: var(--apagado);
  }
`;

export const Anos = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem;

  button {
    padding: 0.6rem 0.8rem;
    border: 1px solid var(--linha);
    border-radius: 3px;
    font-size: 0.8125rem;
    transition: background 0.15s, border-color 0.15s;
  }

  button:hover {
    border-color: #b9c8bd;
  }

  button[aria-pressed='true'] {
    border-color: var(--tinta);
    background: var(--tinta);
    color: #fff;
  }

  /* Tablet: a coluna dos filtros estreita; os três botões dividem a linha em vez
     de o último cair para baixo. */
  @media (max-width: 1150px) and (min-width: 721px) {
    flex-wrap: nowrap;

    button {
      flex: 1 1 0;
      min-width: 0;
      padding-inline: 0.25rem;
      text-align: center;
    }
  }
`;

/* Seta própria, com respiro da borda (a do navegador fica colada), igual à das
   listas de Nossas unidades. */
export const OutrosAnos = styled.select`
  width: 100%;
  margin-top: 0.1rem;
  padding: 0.7rem 2.4rem 0.7rem 0.6rem;
  border: 1px solid ${({ $ativo }) => ($ativo ? 'var(--tinta)' : 'var(--linha)')};
  border-radius: 3px;
  appearance: none;
  background: #fff
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%236b7b72' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E")
    no-repeat right 0.8rem center;
  color: var(--tinta);
  cursor: pointer;

  /* "&&": o "select { font: inherit }" da página é mais forte e apagava o
     tamanho daqui. 16px no celular evita o zoom automático do iPhone ao tocar. */
  && {
    font-size: 0.875rem;
  }

  @media (max-width: 720px) {
    max-width: 18.75rem;

    && {
      font-size: 1rem;
    }
  }
`;

export const RotuloOutrosAnos = styled.label`
  margin-top: 1.4rem;
`;

export const Limpar = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  margin-top: 1.7rem;
  padding: 0;
  border: 0;
  font-size: 0.75rem;
  color: var(--tinta);

  &:disabled {
    opacity: 0.45;
    cursor: default;
  }

  /* No celular: área de toque maior que o texto, com o mesmo espaço visual
     (a margem perde o que o padding ganha). */
  @media (max-width: 720px) {
    margin-top: 0.5rem;
    padding: 0.6rem 0;
  }
`;

export const Contagem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 1.2rem;
  border-bottom: 1px solid var(--linha);

  h2 {
    margin: 0;
    font-size: 1.5rem;
    font-weight: 500;
  }

  span {
    font-size: 0.75rem;
    color: var(--apagado);
  }
`;

/* Linha editorial: data | texto | foto. */
export const Linha = styled.article`
  display: grid;
  grid-template-columns: 7.8rem minmax(0, 1fr) ${({ $semFoto }) => ($semFoto ? '' : '14.0625rem')};
  gap: 1.4rem;
  align-items: start;
  padding: 1.9rem 0;
  border-bottom: 1px solid var(--linha);

  &:last-of-type {
    border-bottom: 0;
  }

  @media (max-width: 1050px) {
    grid-template-columns: 6.9rem minmax(0, 1fr) ${({ $semFoto }) => ($semFoto ? '' : '12.2rem')};
    gap: 1.1rem;
  }

  @media (max-width: 950px) {
    grid-template-columns: 6.5rem minmax(0, 1fr);
  }

  /* Tela pequena: foto, data e texto um embaixo do outro, o texto na largura toda. */
  @media (max-width: 720px) {
    grid-template-columns: minmax(0, 1fr);
    gap: 1rem;
    padding: 1.6rem 0;
  }
`;

export const LinhaData = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.55rem;

  /* Dia grande, quase da largura de "mês · ano" embaixo. */
  span {
    font-family: ${serifa};
    font-size: 5.5rem;
    line-height: 0.85;
    letter-spacing: -0.03em;
    color: #8a9e8d;
  }

  /* No limite da coluna: "fevereiro · 2026", o mais comprido, ainda cabe numa linha. */
  small {
    font-size: 1rem;
    line-height: 1.5;
    white-space: nowrap;
    color: var(--apagado);
  }

  @media (max-width: 1050px) {
    span {
      font-size: 4.75rem;
    }

    small {
      font-size: 0.875rem;
    }
  }

  /* Numa linha só, antes do título: "31 agosto · 2026". */
  @media (max-width: 720px) {
    grid-row: 2;
    flex-direction: row;
    align-items: baseline;
    gap: 0.6rem;

    span {
      font-size: 2.75rem;
    }

    small {
      font-size: 0.8125rem;
    }
  }
`;

export const LinhaTexto = styled.div`
  min-width: 0;

  h3 {
    margin: 0 0 0.75rem;
    font-size: 1.5rem;
    font-weight: 500;
    line-height: 1.3;
    letter-spacing: -0.02em;
  }

  p {
    max-width: 34rem;
    margin: 0 0 0.6rem;
    font-size: 0.875rem;
    line-height: 1.75;
    color: var(--apagado);
  }

  @media (max-width: 1050px) {
    h3 {
      font-size: 1.375rem;
    }
  }

  @media (max-width: 720px) {
    grid-row: 3;

    h3 {
      font-size: 1.4375rem;
    }
  }
`;

/* "Ler notícia →": cresce um pouco e a seta anda no hover. */
export const Acao = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0;
  font-size: 0.9375rem;
  color: var(--tinta);
  transform-origin: ${({ $direita }) => ($direita ? 'right center' : 'left center')};
  transition: transform 0.2s ease;

  svg {
    flex-shrink: 0;
    transition: transform 0.2s ease;
  }

  &:hover,
  &:focus-visible {
    transform: scale(1.025);
  }

  &:hover svg,
  &:focus-visible svg {
    transform: translateX(${({ $voltar }) => ($voltar ? '-4px' : '4px')});
  }
`;

export const LinhaFoto = styled(Link)`
  display: block;
  width: 14.0625rem;
  height: 10.9rem;
  overflow: hidden;
  border-radius: 2px;
  background: #e7ece4;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (max-width: 1050px) {
    width: 12.2rem;
    height: 10.3rem;
  }

  @media (max-width: 950px) {
    grid-column: 2;
    grid-row: 2;
    width: 100%;
    height: 12.5rem;
  }

  @media (max-width: 720px) {
    grid-column: 1 / -1;
    grid-row: 1;
    height: 13.75rem;
  }
`;

/* Igual ao "Carregar mais" da galeria. */
export const MaisPublicacoes = styled.button`
  display: block;
  margin: 1.9rem auto 0;
  padding: 0.85rem 1.6rem;
  border: 1px solid var(--verde-escuro);
  border-radius: 4px;
  background: transparent;
  font-size: 0.8125rem;
  color: var(--verde-escuro);
  transition: background 0.2s, color 0.2s;

  &:hover {
    background: var(--verde-escuro);
    color: #fff;
  }
`;

export const Vazio = styled.p`
  padding: 2.2rem 0;
  margin: 0;
  font-size: 0.875rem;
  color: var(--apagado);
`;

export const Fim = styled.div`
  display: flex;
  align-items: center;
  gap: 1.25rem;
  margin-top: 4rem;
  font-size: 0.625rem;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--apagado);

  &::before,
  &::after {
    content: '';
    flex: 1;
    height: 1px;
    background: var(--linha);
  }

  @media (max-width: 720px) {
    gap: 0.6rem;
    margin-top: 2.5rem;
    font-size: 0.5rem;
    letter-spacing: 0.04em;
  }
`;

/* ----------------------------------------------------------- faixa final */

export const FaixaFinal = styled.section`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2.8rem;
  padding: 4.7rem 0 6.25rem;

  > span {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    font-size: 0.75rem;
    letter-spacing: 0.12em;
    text-transform: uppercase;
  }

  > span::before {
    content: '';
    width: 2.5rem;
    height: 1px;
    background: #7a9c86;
  }

  p {
    position: relative;
    margin: 0;
    padding-top: 1.75rem;
    font-family: ${serifa};
    font-size: clamp(1.875rem, 3vw, 2.625rem);
    line-height: 1.3;
    text-align: right;
  }

  /* Traço âmbar abrindo a frase, como na galeria (aqui no canto direito). */
  p::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 3rem;
    height: 3px;
    border-radius: 2px;
    background: var(--sixth-color);
  }

  @media (max-width: 720px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 2.2rem;
    padding: 2.8rem 0 4rem;

    > span {
      order: 2;
      font-size: 0.625rem;
    }

    p {
      font-size: 1.875rem;
      text-align: left;
    }

    p::before {
      right: auto;
      left: 0;
    }
  }
`;

/* =============================================================== matéria */

export const Progresso = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  height: 3px;
  background: var(--amarelo);
  pointer-events: none;
`;

export const Cabecalho = styled.header`
  max-width: 68rem;
  margin: 2.8rem 0 2.4rem;

  h1 {
    margin: 0 0 1.55rem;
    font-family: ${serifa};
    font-size: clamp(2.375rem, 4.7vw, 4.0625rem);
    font-weight: 400;
    line-height: 1.09;
    letter-spacing: -0.028em;
    text-wrap: balance;
  }

  p {
    max-width: 52rem;
    margin: 0;
    font-size: 1.125rem;
    line-height: 1.7;
    color: var(--apagado);
  }

  @media (max-width: 720px) {
    margin-top: 2.2rem;

    h1 {
      font-size: 2.5rem;
      letter-spacing: -0.02em;
    }

    p {
      font-size: 1rem;
    }
  }
`;

const botaoAmpliar = css`
  position: absolute;
  right: 1.1rem;
  bottom: 1.1rem;
  z-index: 2;
  display: grid;
  place-items: center;
  width: 2.4rem;
  height: 2.4rem;
  border: 0;
  border-radius: 50%;
  background: #fff;
  color: var(--tinta);
  box-shadow: 0 2px 10px rgba(18, 51, 34, 0.18);
  transition: transform 0.2s;

  &:hover {
    transform: scale(1.08);
  }

  @media (max-width: 720px) {
    right: 0.75rem;
    bottom: 0.75rem;
    width: 2.25rem;
    height: 2.25rem;
  }
`;

export const Capa = styled.figure`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 10rem;
  gap: 1.55rem;
  align-items: end;
  margin: 2.2rem 0 3.1rem;

  > div {
    position: relative;
    overflow: hidden;
    background: #e7ece4;
  }

  img {
    width: 100%;
    height: 32.5rem;
    object-fit: cover;
  }

  img[data-retrato] {
    object-fit: contain;
  }

  button {
    ${botaoAmpliar}
  }

  figcaption {
    padding-bottom: 0.95rem;
    border-bottom: 1px solid var(--linha);
    font-size: 0.75rem;
    line-height: 1.9;
    color: var(--apagado);
  }

  figcaption > span {
    display: block;
    margin-bottom: 0.75rem;
    font-size: 0.5625rem;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    color: var(--verde);
  }

  @media (max-width: 1050px) {
    grid-template-columns: minmax(0, 1fr) 8.125rem;

    img {
      height: 28rem;
    }
  }

  @media (max-width: 720px) {
    display: block;
    margin-bottom: 1.9rem;

    img {
      height: 18.75rem;
    }

    img[data-retrato] {
      height: 26rem;
    }

    /* sem a linha de baixo: o trilho logo abaixo já abre com uma, e ficavam duas */
    figcaption {
      margin-top: 0.75rem;
      padding-bottom: 0;
      border-bottom: 0;
    }

    figcaption > span {
      display: inline;
      margin-right: 0.75rem;
      font-size: 0.625rem;
    }
  }
`;

export const Leitura = styled.div`
  display: grid;
  grid-template-columns: 11.25rem minmax(0, 51.25rem);
  gap: 4.4rem;
  align-items: start;
  max-width: 68.75rem;
  margin: 0 auto 3.1rem;

  @media (max-width: 1050px) {
    grid-template-columns: 9.4rem minmax(0, 1fr);
    gap: 2.2rem;
  }

  @media (max-width: 720px) {
    display: block;
    margin-bottom: 2.8rem;
  }
`;

export const Trilho = styled.aside`
  /* Como os filtros da lista: só acompanha a rolagem quando chega perto do topo. */
  position: sticky;
  top: 2rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 0.8125rem;
  line-height: 1.8;
  color: var(--apagado);

  > p {
    ${Chapeu}
    margin: 0 0 0.6rem;
    font-size: 0.6875rem;
  }

  hr {
    width: 2.8rem;
    margin: 1.25rem 0;
    border: 0;
    border-top: 1px solid var(--linha);
  }

  button {
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
    padding: 1.55rem 0 0;
    border: 0;
    font-size: 0.75rem;
    color: var(--verde);
  }

  @media (max-width: 720px) {
    position: static;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.6rem 1.25rem;
    margin-bottom: 1.75rem;
    padding: 0.95rem 0;
    border-block: 1px solid var(--linha);

    > p,
    hr {
      display: none;
    }

    /* área de toque maior que o texto, sem mudar o espaço que ocupa */
    button {
      padding: 0.6rem 0;
      margin: -0.6rem 0;
    }
  }
`;

export const Texto = styled.div`
  font-size: 1.125rem;
  line-height: 1.95;
  color: #43594d;
  overflow-wrap: anywhere;
  /* Justificado, com hifenização (lang="pt-BR" no bloco). No bloco todo, e não
     só no <p>: matéria antiga às vezes tem texto solto, fora de parágrafo. */
  text-align: justify;
  hyphens: auto;

  h2,
  h3,
  h4,
  blockquote {
    text-align: left;
  }

  p {
    margin: 0 0 1.6rem;
  }

  h2,
  h3,
  h4 {
    margin: 2.5rem 0 0.95rem;
    font-size: 1.6875rem;
    font-weight: 500;
    line-height: 1.3;
    color: var(--tinta);
  }

  h3,
  h4 {
    font-size: 1.3rem;
  }

  a {
    color: var(--verde);
    text-decoration: underline;
    text-underline-offset: 3px;
  }

  ul,
  ol {
    margin: 0 0 1.6rem;
    padding-left: 1.3rem;
  }

  blockquote {
    margin: 2rem 0;
    padding: 0.2rem 0 0.2rem 1.25rem;
    border-left: 3px solid var(--amarelo);
    font-family: ${serifa};
    font-size: 1.3rem;
    color: var(--tinta);
  }

  img {
    max-width: 100%;
    height: auto;
  }

  /* Capitular verde só no primeiro parágrafo da matéria. */
  ${({ $capitular }) =>
    $capitular &&
    css`
      > p:first-child::first-letter {
        float: left;
        padding: 0.55rem 0.6rem 0 0;
        font-family: ${serifa};
        font-size: 4.375rem;
        line-height: 0.85;
        color: var(--verde);
      }
    `}

  /* No celular a coluna é estreita e o justificado abre buracos entre as palavras. */
  @media (max-width: 720px) {
    font-size: 1.0625rem;
    line-height: 1.9;
    text-align: left;
  }
`;

export const Fotos = styled.div`
  display: grid;
  grid-template-columns: ${({ $quantas }) => ($quantas === 1 ? '1fr' : '1fr 1fr')};
  gap: 0.75rem;
  margin: 2.2rem -1.25rem;

  figure {
    min-width: 0;
    margin: 0;
  }

  button {
    position: relative;
    display: block;
    width: 100%;
    padding: 0;
    border: 0;
    border-radius: 5px;
    overflow: hidden;
    background: #e8ece5;
    cursor: zoom-in;
  }

  img {
    width: 100%;
    height: ${({ $quantas, $deitadas }) => ($quantas === 1 ? '30rem' : $deitadas ? '16.25rem' : '22.5rem')};
    object-fit: cover;
  }

  img[data-retrato] {
    object-fit: contain;
  }

  figcaption {
    margin-top: 0.7rem;
    font-size: 0.75rem;
    line-height: 1.6;
    color: var(--apagado);
  }

  /* Celular: uma foto embaixo da outra, cada uma inteira na proporção dela. */
  @media (max-width: 720px) {
    grid-template-columns: 1fr;
    margin: 1.9rem 0;

    img {
      height: auto;
    }
  }
`;

export const Vizinhas = styled.nav`
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin: 1rem 0 5rem;
  padding-top: 1.9rem;
  border-top: 1px solid var(--linha);

  > div {
    min-width: 0;
    padding: 0.6rem 2.5rem 1rem 0;
  }

  > div + div {
    padding: 0.6rem 0 1rem 2.5rem;
    border-left: 1px solid var(--linha);
    text-align: right;
  }

  h2 {
    margin: 1rem 0 0.95rem;
    font-family: ${serifa};
    font-size: 1.6875rem;
    font-weight: 400;
    line-height: 1.3;
    letter-spacing: -0.01em;
  }

  time,
  p {
    font-size: 0.75rem;
    color: var(--apagado);
  }

  p {
    margin: 1rem 0 0;
    font-size: 0.875rem;
    line-height: 1.8;
  }

  > div > span {
    font-size: 1rem;
    color: var(--apagado);
  }

  @media (max-width: 720px) {
    grid-template-columns: 1fr;
    margin-bottom: 3.4rem;
    padding-top: 0.95rem;

    > div,
    > div + div {
      padding: 1.25rem 0;
      border-left: 0;
      text-align: left;
    }

    > div + div {
      border-top: 1px solid var(--linha);
    }

    h2 {
      font-size: 1.5625rem;
    }
  }
`;

export const Aviso = styled.div`
  position: fixed;
  left: 50%;
  bottom: 5.3rem;
  z-index: 60;
  padding: 0.75rem 1.25rem;
  border-radius: 4px;
  background: var(--tinta);
  color: #fff;
  font-size: 0.75rem;
  transform: translateX(-50%);
`;
